<div class="shuttle-comparison-container">
  <div class="comparison-header">
    <div class="fs-6 fw-bold d-flex flex-row align-items-center mb-3">
      <mat-icon class="me-2">compare_arrows</mat-icon>
      <h3>Shuttle Operations Year Comparison</h3>
      <!-- <mat-spinner *ngIf="isLoading" class="ms-3" [diameter]="20" [strokeWidth]="2"></mat-spinner> -->
    </div>

    <div class="comparison-controls">
      <div class="year-selectors">
        <mat-form-field appearance="outline" class="year-field">
          <mat-label>Primary Year</mat-label>
          <mat-select [(value)]="primaryYear" (selectionChange)="onPrimaryYearChange()" [disabled]="isLoading">
            @for (year of availableYears; track year) {
            <mat-option [value]="year">
              {{year}}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <div class="comparison-divider"></div>

        <mat-form-field appearance="outline" class="year-field">
          <mat-label>Comparison Year</mat-label>
          <mat-select [(value)]="comparisonYear" (selectionChange)="onComparisonYearChange()" [disabled]="isLoading">
            @for (year of availableYears; track year) {
            <mat-option [value]="year">
              {{year}}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="date-range-field">
        <mat-label>Date Range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate placeholder="Start date" [(ngModel)]="selectedStartDate" [disabled]="isLoading">
          <input matEndDate placeholder="End date" [(ngModel)]="selectedEndDate" [disabled]="isLoading"
            (dateChange)="onDateRangeChange()">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
      <div class="d-flex align-items-center gap-2">
        <span class="time-axis-label">Time Axis</span>
        <mat-button-toggle-group [disabled]="isLoading" class="time-axis-btns" [(value)]="timeAxisMode"
          (change)="switchTimeAxis($event)">
          <mat-button-toggle value="days">Days</mat-button-toggle>
          <mat-button-toggle value="hours">Hours</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    </div>
  </div>

  <!-- Single Combined Chart -->
  <div class="chart-section">
    <!-- <div class="chart-header">
  </div> -->

    <div class="chart-container chart-container--xl">
      <canvas baseChart [data]="combinedChartData" [options]="combinedChartOptions" [type]="'line'"></canvas>
    </div>
  </div>

  <!-- Updated Legend Info -->
  <div class="legend-info">
    <div class="legend-item">
      <div class="legend-line solid"></div>
      <span>{{primaryYear}} Data</span>
    </div>
    <div class="legend-item">
      <div class="legend-line dashed"></div>
      <span>{{comparisonYear}} Data</span>
    </div>
  </div>
</div>